<template>
  <div class="flex flex-col items-center gap-4 pt-4 border-t border-t-lumar-gray">
    <div class="flex items-center gap-4 text-xs text-lumar-gray">
      <span>Splošni pogoji</span>
      <div class="w-[1px] self-stretch bg-lumar-gray" />
      <span>Politika zasebnosti</span>
      <div class="w-[1px] self-stretch bg-lumar-gray" />
      <span>Lumar</span>
    </div>
    <div class="text-xs text-lumar-gray">
      <span>© 2025 Lumar IG d.o.o. Vse pravice pridržane.</span>
    </div>
  </div>
</template>
